<div
  class="text-muted d-sm-flex justify-content-between mb-3"
  style="width: 100%">
  <div
    class="filter-results filter-container filter-row d-flex flex-wrap flex-row align-items-center">
    <div class="fw-bold me-2">Filter results:</div>

    <ng-container *ngIf="searchFilters?.type && searchFilters?.type != ''">
      <div
        (click)="removeTypeFilter()"
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1">
        <i class="bi bi-code-square p-1"></i>
        <span *ngIf="searchFilters?.type == 'diy'">{{
          searchFilters.type | uppercase
        }}</span>
        <span *ngIf="searchFilters?.type !== 'diy'">{{
          searchFilters.type | titlecase
        }}</span>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <ng-container *ngIf="searchFilters?.created_by">
      <div
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1"
        (click)="removeCreatedByFilter()">
        <i class="bi bi-person p-1"></i>
        <ng-container [ngSwitch]="searchFilters.created_by">
          <span *ngSwitchCase="'me'">Me</span>
          <span *ngSwitchCase="'e2l'">e2L Admin</span>
          <span *ngSwitchCase="'district'">My District</span>
          <span *ngSwitchDefault></span>
        </ng-container>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <ng-container *ngIf="searchFilters && searchFilters.tags">
      <div
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1"
        (click)="removeTagFilter(tag)"
        *ngFor="let tag of searchFilters.tags">
        <i class="bi bi-tag p-1"></i>
        <span>{{ tag }}</span>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <ng-container *ngFor="let author of authors">
      <div
        *ngIf="author['name']"
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1"
        (click)="removeAuthor(author)">
        <i class="bi bi-person p-1"></i>
        <span>{{ author["name"] }}</span>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <ng-container *ngFor="let competency of competencies">
      <div
        *ngIf="competency['title']"
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1"
        (click)="removeCompetency(competency)">
        <i class="bi bi-file-earmark-check p-1"></i>
        <span>{{ competency["title"] }}</span>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <ng-container *ngIf="searchFilters && searchFilters.levels">
      <div
        *ngFor="let level of searchFilters.levels"
        class="badge rounded-pill text-bg-secondary p-1 me-2 mx-1"
        (click)="removeLevelFilter(level)">
        <i class="bi bi-123 p-1"></i>
        <span>Level {{ level }}</span>
        <i class="bi bi-x-circle-fill p-1 ms-1"></i>
      </div>
    </ng-container>

    <app-resource-filter-modal
      #filterModal
      [filterType]="'Sort By'"
      (currentCompentenciesEvent)="handleCompetencies($event)"
      (currentAuthorsEvent)="handleAuthors($event)"></app-resource-filter-modal>
  </div>
  <div class="sort-by d-flex flex-row align-items-center text-nowrap">
    <div class="fw-bold me-2">Sort By:</div>
    <div class="form-check me-2">
      <input
        class="form-check-input"
        type="radio"
        name="sortByRadioFilter"
        id="sortByRadioFilterRelevancy"
        value="search_score"
        (click)="handleSortBy('search_score')"
        [(ngModel)]="searchFilters!.order" />
      <label class="form-check-label" for="sortByRadioFilterRelevancy"
        >Relevancy</label
      >
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="radio"
        name="sortByRadioFilter"
        id="sortByRadioFilterPopularity"
        value="trend_score"
        (click)="handleSortBy('trend_score')"
        [(ngModel)]="searchFilters!.order" />
      <label class="form-check-label" for="sortByRadioFilterPopularity"
        >Popularity</label
      >
    </div>
  </div>
</div>
